import WebServiceRequest from './WebServiceRequest'

class WalletGetRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('Wallets/Get')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class WalletUpdateRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('Wallet/Update')
  }

  setParams(data) {
    super.setRequestParamDataObj(data)
  }
}

class WalletGetMyWalletsRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('Wallet/GetMyWallets')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class GetAllWithdrawRequests extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('WithdrawRequests/GetAllWithdrawRequests')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class ChangeWithdrawRequestStatus extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setTag('WithdrawRequests/VerifyWithdrawRequestByAdmin')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class DeleteWithdrawRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('DELETE')
    super.setTag('WithdrawRequests/DeleteWithdrawRequestBy')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class WalletGetAllRequest extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('Wallets/GetAll')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class WalletGetTransactionsForWallet extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('GET')
    super.setTag('Wallets/GetWalletTransactionHistory')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class WalletDeposit extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')

    super.setTag('Wallets/Deposite')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

class WalletWithdraw extends WebServiceRequest {
  constructor(context) {
    super(context)
    super.setMethod('POST')
    super.setTag('Wallets/Withdraw')
  }

  setParams(data) {
    super.setRequestParam(data)
  }
}

export {
  WalletDeposit,
  GetAllWithdrawRequests,
  WalletWithdraw,
  WalletUpdateRequest,
  WalletGetMyWalletsRequest,
  WalletGetAllRequest,
  WalletGetRequest,
  WalletGetTransactionsForWallet,
  ChangeWithdrawRequestStatus,
  DeleteWithdrawRequest
}
